import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

const FooterLogo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <Link to="/">
          <Image
           src={require('./../../../assets/images/NoteBlock_short_logo_tm.png')}
            alt="Open"
            width={560}
            height={400} />
        </Link>
      </h1>
    </div>
  );
}

export default FooterLogo;